<dx-box #workflowPaymentRequestForm height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto" [visible]="!isPopup">
        <h2 class="page-header">
            Submit Invoice/Payment Request
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" [ngClass]="iconHelp"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1">
        <dx-box width="100%" height="100%" direction="col" class="cc-white-background request-box-container">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="splitter-container">
                        <as-split
                            class="as-split"
                            direction="horizontal"
                            unit="percent"
                            gutterSize="5"
                            [useTransition]="true"
                            (dragEnd)="dragEndPdfLeft($event)"
                            (dragStart)="onSplitterDragStart()"
                        >
                            <as-split-area [size]="formPanelWidth" [order]="invoiceOrder">
                                <dx-box width="100%" height="100%" direction="col" class="invoice-box-container">
                                    <dxi-item [ratio]="1">
                                        <div *dxTemplate>
                                            <dx-scroll-view
                                                #paymentInfoScrollView
                                                width="100%"
                                                height="100%"
                                                [scrollByContent]="true"
                                                [scrollByThumb]="true"
                                            >
                                                <dx-box width="100%" height="95vh" direction="col">
                                                    <dxi-item baseSize="auto">
                                                        <div *dxTemplate>
                                                            <app-workflow-payment-request-simple
                                                                #submitInvoice
                                                                [selectedCommunityId]="communityId"
                                                                (onInvoiceSelection)="onInvoiceSelection($event)"
                                                                (onInvoiceOptionChange)="onInvoiceOptionChange($event)"
                                                                (onCommunitySelectionChange)="
                                                                    onCommunitySelectionChange($event)
                                                                "
                                                            ></app-workflow-payment-request-simple>
                                                        </div>
                                                    </dxi-item>
                                                    <dxi-item baseSize="auto">
                                                        <div *dxTemplate>
                                                            <app-workflow-payment-request-toolbar
                                                                #paymentToolbar
                                                                [communityId]="community?.communityId"
                                                                [boardApproval]="boardApproved"
                                                                [selectedVendor]="selectedVendor"
                                                                [invoiceOption]="invoiceOption"
                                                                (onAdvanceModeSelectionChange)="
                                                                    onAdvanceModeSelectionChange($event)
                                                                "
                                                                (onWorkOrderSelection)="onWorkOrderSelection($event)"
                                                            ></app-workflow-payment-request-toolbar>
                                                        </div>
                                                    </dxi-item>
                                                    <dxi-item [ratio]="1">
                                                        <div *dxTemplate>
                                                            <app-workflow-payment-request-details
                                                                #paymentDetails
                                                                *ngIf="showAdvanceMode"
                                                                [community]="community"
                                                                [vendorCode]="vendorCode"
                                                                (onVendorPayeeSelection)="
                                                                    onVendorPayeeSelection($event)
                                                                "
                                                                (isBoardApproved)="isBoardApproved($event)"
                                                            ></app-workflow-payment-request-details>
                                                        </div>
                                                    </dxi-item>
                                                </dx-box>
                                            </dx-scroll-view>
                                        </div>
                                    </dxi-item>
                                    <dxi-item baseSize="auto">
                                        <div *dxTemplate>
                                            <dx-toolbar width="100%">
                                                <dxi-item location="before">
                                                    <div *dxTemplate>
                                                        <dx-button
                                                            type="default"
                                                            text="Reset"
                                                            hint="Reset"
                                                            [icon]="iconReset"
                                                            (onClick)="onResetClick()"
                                                        ></dx-button>
                                                    </div>
                                                </dxi-item>
                                                <dxi-item location="before" [visible]="!!isPopup">
                                                    <div *dxTemplate>
                                                        <dx-button
                                                            type="default"
                                                            text="Close"
                                                            hint="Close"
                                                            [icon]="iconClose"
                                                            (onClick)="onPaymentRequestClose()"
                                                        ></dx-button>
                                                    </div>
                                                </dxi-item>
                                                <dxi-item location="after">
                                                    <div *dxTemplate>
                                                        <dx-button
                                                            type="success"
                                                            text="Submit For Data Processing"
                                                            hint="Submit For Data Processing"
                                                            [icon]="iconStar"
                                                            [disabled]="isProcessingDisabled"
                                                            (onClick)="onSubmitProcessing()"
                                                        ></dx-button>
                                                    </div>
                                                </dxi-item>
                                            </dx-toolbar>
                                        </div>
                                    </dxi-item>
                                </dx-box>
                            </as-split-area>
                            <as-split-area
                                class="as-split-area"
                                [size]="pdfViewerWidth"
                                [order]="pdfOrder"
                                [visible]="!separateWindow"
                            >
                                <div class="invoice-viewer-container">
                                    <app-workflow-invoice-viewer
                                        #invoiceViewer
                                        [source]="pdfURL"
                                        [loader]="pdfLoader"
                                    ></app-workflow-invoice-viewer>
                                </div>
                            </as-split-area>
                        </as-split>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<cc-message-box #workflowSubmitInvoiceForm></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowPaymentRequestForm' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
